/** Shared visual state classes for radio-style primitives (RadioCard, RadioChip). */
export const RADIO_CHECKED_CLASSES =
	"outline outline-brand-accent outline-[2px] outline-offset-[-2px] bg-brand-accent/[.06]";

export const RADIO_DISABLED_CLASSES =
	"opacity-55 bg-surface-neutral cursor-not-allowed hover:border-bc-default hover:bg-surface-neutral";
